
import React from 'react';

interface SizeReminderNoteProps {
  gender: 'male' | 'female';
}

const SizeReminderNote: React.FC<SizeReminderNoteProps> = ({ gender }) => {
  return (
    <div className={`
      p-4 rounded-lg shadow-sm border 
      ${gender === 'male' ? 'bg-blue-50 border-blue-100' : 'bg-pink-50 border-pink-100'}
    `}>
      <p className={`text-sm ${gender === 'male' ? 'text-blue-700' : 'text-pink-700'}`}>
        <span className="font-semibold">Lưu ý:</span> Hãy chọn kích thước áo phù hợp với cơ thể bạn.
        Nếu bạn thích mặc áo rộng, hãy chọn size lớn hơn.
      </p>
    </div>
  );
};

export default SizeReminderNote;
